import { createContext, useContext, useState, useEffect, useCallback } from "react"
import { api } from "../lib/api"

type NotificationsContextData = {
  unreadCount: number
  refreshUnreadCount: () => void
}

const NotificationsContext = createContext<NotificationsContextData>({
  unreadCount: 0,
  refreshUnreadCount: () => {},
})

export const NotificationsProvider = ({ children }: { children: React.ReactNode }) => {
  const [unreadCount, setUnreadCount] = useState(0)

  const refreshUnreadCount = useCallback(async () => {
    try {
      const data = await api.get<{ unread_count: number }>("/notifications/unread_count")
      setUnreadCount(data.unread_count)
    } catch {
      // ignore
    }
  }, [])

  useEffect(() => {
    refreshUnreadCount()
  }, [refreshUnreadCount])

  return (
    <NotificationsContext.Provider value={{ unreadCount, refreshUnreadCount }}>
      {children}
    </NotificationsContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useNotifications = () => useContext(NotificationsContext)
